<template>
  <div class="common-rate-list">
    <van-sticky
      v-if="showRateTabs"
      ref="tabs"
      :offset-top="scrollDirection === 1 ? stickOffsetTop : zxStickOffsetTop"
    >
      <ul class="two-floor-tabs">
        <li
          class="two-tab"
          v-for="tab in rateTypeTabs"
          :key="tab.name"
          :class="{ [tab.name]: true, active: tab.name === commonRateType }"
          @click="onTabChange(tab.name)"
        >
          {{ tab.title }}
        </li>
      </ul>
    </van-sticky>
    <template v-if="isConsultTeacher">
      <evaluateList v-show="commonRateType === 'consult'" />
    </template>
    <template v-if="isQingtingTeacher">
      <qingsuRateList v-show="commonRateType === 'qingsu'" />
    </template>
  </div>
</template>

<script>
import evaluateList from 'component/platform/homepage/tabList/evaluateList.vue'
import qingsuRateList from 'component/platform/homepage/qingsuTeacher/qingsuRateList.vue'
import { Sticky } from 'vant'
import { getOffsetTop } from 'lib/tools/domUtil.js'

export default {
  components: {
    evaluateList,
    qingsuRateList,
    [Sticky.name]: Sticky
  },
  props: {
    showZxTabsDistance: Number,
    scrollDirection: Number
  },
  data() {
    return {}
  },
  computed: {
    rateTypeTabs() {
      const tabs = []
      if (this.isConsultTeacher && this.rateList.length) {
        tabs.push({
          name: 'consult',
          title: '咨询'
        })
      }
      if (this.isQingtingTeacher && this.qingsuRateList.length) {
        tabs.push({
          name: 'qingsu',
          title: '倾诉'
        })
      }
      return tabs
    },
    showRateTabs() {
      return this.rateTypeTabs.length > 1
    },
    commonRateType() {
      return this.$store.state.homepage.commonRateType
    },
    //咨询评价
    rateList() {
      return this.$store.getters['homepage/getRateListData'] || []
    },
    // 倾诉评价
    qingsuRateList() {
      return this.$store.state.homepage.qingsuRateInfo.list
    },
    zxStickOffsetTop() {
      return this.$store.getters['homepage/zxStickOffsetTop']
    },
    stickOffsetTop() {
      return this.$store.getters['homepage/stickOffsetTop']
    },
    distance() {
      return this.$store.state.homepage.distance
    },
    isConsultTeacher() {
      return this.$store.getters['homepage/isConsultTeacher']
    },
    isQingtingTeacher() {
      return this.$store.getters['homepage/isQingtingTeacher']
    }
  },
  mounted() {
    // 接口返回时间不确定，暂时先设置延迟
    setTimeout(() => {
      if (!this.isConsultTeacher || !this.rateList.length) {
        this.$store.commit('homepage/SET_COMMON_RATE_TYPE', 'qingsu')
      }
    }, 1000)
  },
  methods: {
    onTabChange(type) {
      this.$store.commit('homepage/SET_COMMON_RATE_TYPE', type)
      const offsetTop = getOffsetTop(this.$refs.tabs.$el)
      const scrollTop =
        offsetTop -
        this.distance.headerHeight -
        (this.scrollDirection === 1
          ? this.stickOffsetTop
          : this.zxStickOffsetTop)
      window.yxl = window.yxl || {}
      window.yxl.ignoreScrollDirection = true
      window.yxl.ignoreScrollHandler = true
      window.scrollTo(0, scrollTop)
      // 300毫秒内，不获取滚动方向，不触发_scrollHandler
      setTimeout(() => {
        window.yxl.ignoreScrollDirection = false
        window.yxl.ignoreScrollHandler = false
      }, 300)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .van-sticky--fixed {
  transition: all 0.2s linear;
}
.common-rate-list {
  .two-floor-tabs {
    position: relative;
    left: 50%;
    transform: translate3d(-50%, 0, 0);
    display: flex;
    align-items: center;
    height: 88px;
    background-color: #fff;
    width: calc(10rem - 60px);
    z-index: $hp_zIndex_tababr;
    box-sizing: border-box;
    .two-tab {
      word-break: keep-all;
      padding: 0 16px;
      height: 60px;
      border-radius: 40px;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #6c798c;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 20px;
      background: #f3f4f5;
      &:last-child {
        margin-right: 0;
      }
      &.active {
        color: #fff;
        &.consult {
          background: #6982fa;
        }
        &.qingsu {
          background: #ff745b;
        }
      }
    }
  }
}
</style>
